import React, { useEffect, useState } from "react";
import Checkmark from "./Checkmark";
import { fontColorFunction } from "../../../../helpers/common";
import _ from "lodash";

// import reviewIconBrown from "/img/checkout/review-logo-Brown.svg";

const TicketsHeader = ({
	curComp,
	query,
	isWidget,
	isLoading,
	handleBackBtn,
	isInternationalEvent,
	selectedTickets,
	orderAmount,
	isWaitlist,
	eventDetails,
	ticketDetails,
}) => {
	const [waitlistOrApproval, setWaitlistOrApproval] = useState(false);

	const addClass = (componentType) => {
		switch (componentType) {
			case "PickTickets":
				if (curComp === 0) return "bg-icon-white";
				else return "bg-icon-orange";
			case "AttendeeDetails":
				if (curComp === 1) return "bg-icon-white";
				else if (curComp === 0) return "bg-icon-blur";
				else return "bg-icon-orange";
			case "ReviewTickets":
				if (curComp === 2) return "bg-icon-white";
				else if (curComp === 1 || curComp === 0) return "bg-icon-blur";
				else return "bg-icon-orange";
		}
	};

	const pickTickets = () =>
		curComp === 0 ? (
			// <img
			//   className="icon-placement"
			//   src="/img/checkout/pick-ticket-brown.svg"
			// />
			<PickTicketLogo query={query} />
		) : (
			<Checkmark
				curComp={curComp}
				query={query}
				color={
					query.tertiaryBg
						? fontColorFunction("#" + query.tertiaryBg)
						: "#fb5850"
				}
			/>
		);
	const attendeeDetails = () => {
		if (curComp !== 2) {
			return (
				// <img
				//   className="icon-placement"
				//   src={
				//     curComp === 1
				//       ? "/img/checkout/attendeeDet-logo-white.svg"
				//       : "/img/checkout/attendeeDet-logo-brown.svg"
				//   }
				// />
				<AttendeeDetailsLogo query={query} curComp={curComp} />
			);
		} else {
			return (
				<Checkmark
					curComp={curComp}
					query={query}
					color={
						query.tertiaryBg
							? fontColorFunction("#" + query.tertiaryBg)
							: "#fb5850"
					}
				/>
			);
		}
	};

	const reviewTickets = () => {
		if (curComp !== 3) {
			return (
				// <img
				//   className="icon-placement"
				//   src={
				//     curComp === 2
				//       ? "/img/checkout/review-logo-white.svg"
				//       : "/img/checkout/review-logo-brown.svg"
				//   }
				// />
				<ReviewTicketsLogo query={query} curComp={curComp} />
			);
		} else {
			return <Checkmark curComp={curComp} query={query} color="#fb5850" />;
		}
	};

	const backButton = () => {
		return <BackButtonLogo query={query} />;
	};

	const line = (comp) => {
		if (comp >= curComp) {
			return <div className="line"></div>;
		} else if (comp < curComp) {
			return <div className="line-orange"></div>;
		}
	};

	useEffect(() => {
		let isWaitorApprov = false;
		if (!_.isEmpty(selectedTickets)) {
			selectedTickets.forEach((ticket) => {
				if (
					(ticket.waitlist_enabled && ticket.sold_out) ||
					(ticket.waitlist_enabled && ticket.remaining_count <= 0)
				) {
					isWaitorApprov = true;
				} else if (ticket.approval_enabled) {
					isWaitorApprov = true;
				}
			});
		}
		setWaitlistOrApproval(isWaitorApprov);
	}, [selectedTickets]);

	return (
		<div>
			{/* For Desktop Screen Size */}
			{!_.isEmpty(ticketDetails) && curComp !== 3 && (
				<div className="header-container d-lg-block d-none">
					<div className="d-flex flex-column justify-content-between h-100 align-items-center icons-container p-2">
						<div className="position-relative">
							<div className="position-relative d-flex justify-content-center">
								<span className={addClass("PickTickets")}></span>
								{pickTickets()}
							</div>
							<span className="header-sub-text">Pick Tickets</span>
						</div>
						{line(0)}
						<div className="position-relative">
							<div className="position-relative d-flex justify-content-center">
								<span className={addClass("AttendeeDetails")}></span>
								{attendeeDetails()}
							</div>
							<span className="header-sub-text text-center">
								Attendee
								<br /> Details
							</span>
						</div>
						{line(1)}
						<div className="position-relative">
							<div className="position-relative d-flex justify-content-center">
								<span className={addClass("ReviewTickets")}></span>
								{reviewTickets()}
							</div>
							<span className="header-sub-text">
								{orderAmount <= 0 ||
									isInternationalEvent ||
									(waitlistOrApproval && !isWaitlist)
									? "Review"
									: "Payment"}
							</span>
						</div>
					</div>
				</div>
			)}

			{/* For Mobile Screen Size */}
			{curComp === 0 && isWidget ? (
				isLoading ? "" :
					<div className="header-sm-container d-lg-none d-md-none">
						<div className="d-flex h-100 align-items-center">
							<div className="position-relative w-100 my-auto pick-tickets-header"> {eventDetails.name} </div>
						</div>
					</div>
			) : (
				<div className="header-sm-container d-lg-none d-md-none">
					<div className="d-flex h-100 align-items-center">
						{/* Back button */}
						{((curComp != 0 && isWidget) || !isWidget) && (
							<div className="position-relative icon-con-back h-100">
								<div className="position-relative icon-inner-back d-flex justify-content-center my-auto">
									<span className=""></span>
									<button
										className="d-inline-block d-md-none p-3 no-button-outline back-btn-checkout-mobile"
										onClick={handleBackBtn}
									>
										{backButton()}
									</button>
								</div>
							</div>
						)}
						<div className="position-relative w-100 my-auto pick-tickets-header"> {eventDetails.name} </div>
						<div className="position-relative my-auto icon-cus pick-tickets-header mobile-screen-header">
							<div className="position-relative d-flex justify-content-center">
								<span className={addClass("PickTickets")}></span>
								{pickTickets()}
							</div>
							<span className="header-sub-text">Tickets</span>
						</div>
						<div className="w-100 mobile-screen-header">{line(0)}</div>
						<div className="position-relative my-auto icon-cus mobile-screen-header">
							<div className="position-relative d-flex justify-content-center ">
								<span className={addClass("AttendeeDetails")}></span>
								{attendeeDetails()}
							</div>
							<span className="header-sub-text">Details</span>
						</div>
						<div className="w-100 mobile-screen-header">{line(1)}</div>
						<div className="position-relative my-auto icon-cus review-tickets-header mobile-screen-header">
							<div className="position-relative d-flex justify-content-center">
								<span className={addClass("ReviewTickets")}></span>
								{reviewTickets()}
							</div>
							<span className="header-sub-text">
								{orderAmount <= 0 ||
									isInternationalEvent ||
									(waitlistOrApproval && !isWaitlist)
									? "Review"
									: "Payment"}
							</span>
						</div>
					</div >
				</div >
			)}
			<style jsx global>{`

        .header-sub-text {
          width: max-content;
          color: ${query.secondaryCl
					? `#${query.secondaryCl}`
					: query.tertiaryBg
						? fontColorFunction("#" + query.tertiaryBg) ==
							"rgba(255, 255, 255, 1)"
							? "#572148"
							: fontColorFunction("#" + query.tertiaryBg)
						: "#572148"
				};
          font-size: 14px;
          float: right;
          margin-top: 5px;
        }

        .icon-placement {
          position: absolute;
          top: 1.2rem;
        }

        .ml-2 {
          margin-left: 10px;
        }
        .mr-2 {
          margin-right: 10px;
        }

        .pick-tickets-header {
          margin-left: 5%;
        }

        .review-tickets-header {
          margin-right: 5%;
        }

        .icons-container {
          background: ${query.secondaryBg
					? `#${query.secondaryBg}`
					: isWidget
						? "#F7F7F7"
						: "#EFE9ED"
				};
          border-radius: ${query.borderRadius || 10}px 0px 0px ${query.borderRadius || 10
				}px;
          animation: slideIn 0.3 forwards;
          -webkit-animation: slideIn 0.3s forwards;
        }

        .header-container {
          overflow: hidden;
          width: 115px;
          height: 100%;
          border: 2px solid ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"};
          border-radius: ${query.borderRadius || 10}px 0px 0px ${query.borderRadius || 10
				}px;
          top: 10px;
          -webkit-backdrop-filter: blur(100px);
          /* Note: backdrop-filter has minimal browser support */
        }

        @keyframes slideIn {
          0% {
            transform: translateX(-115px);
          }
          100% {
            transform: translateX(0px);
          }
        }

        .header-sm-container {
          width: 100%;
          height: 80px;
          padding-left: 0px;
          padding-right: 0px;
          background: ${query.secondaryBg
					? `#${query.secondaryBg}`
					: isWidget
						? "#F7F7F7"
						: "#EFE9ED"
				};
        }

        .icon-con-back {
          background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
        }

        .icon-con-back img {
          transform: translateY(-5px);
        }

        .icon-inner-back {
          height: 80px;
        }

        .icon-cus {
          transform: translateY(5px);
        }

        .icons-sm-size {
          width: 20px;
        }

        .bg-icon-white,
        .bg-icon-blur,
        .bg-icon-orange {
          display: block;
          width: 60px;
          height: 60px;
          border-radius: 100%;
          background-clip: content-box;
          padding: 0.3em;
          transition: 1s all;
        }

        .bg-icon-white {
          background-color: ${query.tertiaryBg
					? `#${query.tertiaryBg}`
					: isWidget
						? "#fb5850"
						: "#572148"
				};
          border: 2px solid ${query.tertiaryBg
					? `#${query.tertiaryBg}`
					: isWidget
						? "#fb5850"
						: "#572148"
				};
        }

        .bg-icon-orange {
          background-color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
          border: 2px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
        }

        .bg-icon-blur {
          background-color: ${query.tertiaryCl ? `#${query.tertiaryCl}` : "white"
				};
          border: 2px solid ${query.tertiaryCl ? `#${query.tertiaryCl}` : "white"
				};
        }

        @media (min-width: 768px) and (max-width: 992px) {
          .bg-icon-blur {
            background-color: ${query.tertiaryCl ? `#${query.tertiaryCl}` : "#EFE9ED"
				};
            border: 2px solid ${query.tertiaryCl ? `#${query.tertiaryCl}` : "#EFE9ED"
				};
          }
          .header-sm-container {
            height: 115px;
            padding-left: 0px;
            padding-right: 0px;
            background: ${query.secondaryBg ? `#${query.secondaryBg}` : "#FFF"};
          }
        }

        @media (min-width: 992px) {
          .line {
            width: 10px;
            height: 100%;
            margin: 0rem 0rem;
            border-left: 5px dotted ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"
				};
            margin: 0.5rem 0rem;
          }
          .line-orange {
            width: 10px;
            height: 100%;
            margin: 0rem 0rem;
            border-left: 5px dotted ${query.btnBg ? `#${query.btnBg}` : "#fb5850"
				};
            margin: 0.5rem 0rem;
          }
        }

        @media (max-width: 991px) {
          .line {
            width: 100%;
            margin: 0rem 0.5rem;
            padding: 0px 0px 15px 25px;
            border-top: 5px dotted ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"
				};
          }
          .line-orange {
            width: 100%;
            margin: 0rem 0.5rem;
            padding: 0px 0px 25px 25px;
            border-top: 5px dotted ${query.btnBg ? `#${query.btnBg}` : "#fb5850"
				};
          }
        }

        @media (max-width: 768px) {
          .bg-icon-white,
          .bg-icon-orange,
          .bg-icon-blur {
            width: 40px;
            height: 40px;
          }
          .icon-placement {
            position: absolute;
            top: 0.55rem;
            width: 13px;
          }
          .checkmark {
            width: 29px !important;
            height: 30px !important;
          }
          .header-sub-text {
            font-size: 12px;
          }
		  .mobile-screen-header{
			display:none !important;
		  }
		  .pick-tickets-header{
			font-family: "prompt";
			font-weight: 600;
			font-size: 16px;
			line-height: 20px;
			color: #000000;
			display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
		  }
        }
      `}</style>
		</div >
	);
};

export default TicketsHeader;

const checkColor = (query, curComp, comp) => {
	if (comp === curComp)
		return query.tertiaryCl
			? `#${query.tertiaryCl}`
			: query.tertiaryBg
				? fontColorFunction("#" + query.tertiaryBg)
				: "white";
	else if (comp !== curComp) return "#572148";
};

const BackButtonLogo = ({ query }) => {
	return (
		<svg
			width="11"
			height="19"
			viewBox="0 0 11 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.18248 17.5621C9.39785 17.5621 9.61742 17.4822 9.78746 17.319C10.1359 16.9849 10.1473 16.4323 9.81504 16.0836L9.81449 16.0831L3.52213 9.49985L9.81448 2.9167L9.81504 2.91612C10.1471 2.56766 10.1359 2.01538 9.78795 1.6812C9.43616 1.34269 8.88415 1.36369 8.5533 1.70486L8.55329 1.70485L8.55049 1.70778L1.68012 8.89539L1.67969 8.89583C1.35731 9.23385 1.35731 9.76585 1.67969 10.1039L1.68012 10.1043L8.55048 17.2919L8.55151 17.293C8.72241 17.4709 8.95205 17.5621 9.18248 17.5621Z"
				fill="none"
				stroke={
					query.tertiaryBg ? fontColorFunction("#" + query.tertiaryBg) : "white"
				}
				strokeWidth="1.12419"
			/>
		</svg>
	);
};

const PickTicketLogo = ({ query }) => {
	return (
		<svg
			className="icon-placement"
			width="28"
			height="22"
			viewBox="0 0 28 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.3125 1.31299V4.33799"
				stroke={
					query.tertiaryCl
						? `#${query.tertiaryCl}`
						: query.tertiaryBg
							? fontColorFunction("#" + query.tertiaryBg)
							: "white"
				}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.3125 18.1978V20.7278"
				stroke={
					query.tertiaryCl
						? `#${query.tertiaryCl}`
						: query.tertiaryBg
							? fontColorFunction("#" + query.tertiaryBg)
							: "white"
				}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.3125 13.9047V7.87842"
				stroke={
					query.tertiaryCl
						? `#${query.tertiaryCl}`
						: query.tertiaryBg
							? fontColorFunction("#" + query.tertiaryBg)
							: "white"
				}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.3767 20.999C24.6543 20.999 26.499 19.1772 26.499 16.928V13.6873C24.9919 13.6873 23.7782 12.4887 23.7782 11.0003C23.7782 9.51196 24.9919 8.31201 26.499 8.31201L26.4977 5.07009C26.4977 2.82083 24.6517 0.999023 22.3754 0.999023H5.62267C3.34638 0.999023 1.50033 2.82083 1.50033 5.07009L1.49902 8.41759C3.00612 8.41759 4.21987 9.51196 4.21987 11.0003C4.21987 12.4887 3.00612 13.6873 1.49902 13.6873V16.928C1.49902 19.1772 3.34378 20.999 5.62136 20.999H22.3767Z"
				stroke={
					query.tertiaryCl
						? `#${query.tertiaryCl}`
						: query.tertiaryBg
							? fontColorFunction("#" + query.tertiaryBg)
							: "white"
				}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
const AttendeeDetailsLogo = ({ query, curComp }) => {
	return (
		<svg
			className="icon-placement"
			width="28"
			height="22"
			viewBox="0 0 28 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.1738 9.30865C22.9176 9.06365 24.2601 7.56865 24.2638 5.7574C24.2638 3.9724 22.9626 2.4924 21.2563 2.2124"
				stroke={checkColor(query, curComp, 1)}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M23.4727 13.5C25.1614 13.7525 26.3402 14.3438 26.3402 15.5625C26.3402 16.4013 25.7852 16.9463 24.8877 17.2888"
				stroke={checkColor(query, curComp, 1)}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.6714 14.0176C9.65391 14.0176 6.22266 14.6263 6.22266 17.0576C6.22266 19.4876 9.63266 20.1138 13.6714 20.1138C17.6889 20.1138 21.1189 19.5113 21.1189 17.0788C21.1189 14.6463 17.7102 14.0176 13.6714 14.0176Z"
				stroke={checkColor(query, curComp, 1)}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.6722 10.5475C16.3085 10.5475 18.446 8.41125 18.446 5.77375C18.446 3.1375 16.3085 1 13.6722 1C11.036 1 8.89847 3.1375 8.89847 5.77375C8.88847 8.40125 11.0097 10.5388 13.6372 10.5475H13.6722Z"
				stroke={checkColor(query, curComp, 1)}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.16812 9.30865C4.42312 9.06365 3.08187 7.56865 3.07812 5.7574C3.07812 3.9724 4.37937 2.4924 6.08562 2.2124"
				stroke={checkColor(query, curComp, 1)}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.8675 13.5C2.17875 13.7525 1 14.3438 1 15.5625C1 16.4013 1.555 16.9463 2.4525 17.2888"
				stroke={checkColor(query, curComp, 1)}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
const ReviewTicketsLogo = ({ query, curComp }) => {
	return (
		<svg
			className="icon-placement"
			width="26"
			height="24"
			viewBox="0 0 26 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.75 5.75H20.5V4.5C20.5 3.50544 20.1049 2.55161 19.4017 1.84835C18.6984 1.14509 17.7446 0.75 16.75 0.75H4.25C3.25544 0.75 2.30161 1.14509 1.59835 1.84835C0.895088 2.55161 0.5 3.50544 0.5 4.5V4.5V19.5C0.5 20.4946 0.895088 21.4484 1.59835 22.1517C2.30161 22.8549 3.25544 23.25 4.25 23.25H21.75C22.7446 23.25 23.6984 22.8549 24.4017 22.1517C25.1049 21.4484 25.5 20.4946 25.5 19.5V9.5C25.5 8.50544 25.1049 7.55161 24.4017 6.84835C23.6984 6.14509 22.7446 5.75 21.75 5.75ZM4.25 3.25H16.75C17.0815 3.25 17.3995 3.3817 17.6339 3.61612C17.8683 3.85054 18 4.16848 18 4.5V5.75H4.25C3.91848 5.75 3.60054 5.6183 3.36612 5.38388C3.1317 5.14946 3 4.83152 3 4.5C3 4.16848 3.1317 3.85054 3.36612 3.61612C3.60054 3.3817 3.91848 3.25 4.25 3.25V3.25ZM23 15.75H21.75C21.4185 15.75 21.1005 15.6183 20.8661 15.3839C20.6317 15.1495 20.5 14.8315 20.5 14.5C20.5 14.1685 20.6317 13.8505 20.8661 13.6161C21.1005 13.3817 21.4185 13.25 21.75 13.25H23V15.75ZM23 10.75H21.75C20.7554 10.75 19.8016 11.1451 19.0983 11.8483C18.3951 12.5516 18 13.5054 18 14.5C18 15.4946 18.3951 16.4484 19.0983 17.1517C19.8016 17.8549 20.7554 18.25 21.75 18.25H23V19.5C23 19.8315 22.8683 20.1495 22.6339 20.3839C22.3995 20.6183 22.0815 20.75 21.75 20.75H4.25C3.91848 20.75 3.60054 20.6183 3.36612 20.3839C3.1317 20.1495 3 19.8315 3 19.5V8.0375C3.40158 8.17877 3.82429 8.25063 4.25 8.25H21.75C22.0815 8.25 22.3995 8.3817 22.6339 8.61612C22.8683 8.85054 23 9.16848 23 9.5V10.75Z"
				fill={checkColor(query, curComp, 2)}
			/>
		</svg>
	);
};
